<template>
    <div>
        <form @submit.prevent="addNewMember()">
            <div class="form-group">
                <select2 v-model="form.member_id">
                    <option :value="null">Choose member</option>
                    <option v-for="member in members" :value="member.id">{{ member.name }}</option>
                </select2>
            </div>
            <hr>
            <div class="form-group">
                <button class="btn btn-primary pull-right">Add</button>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    import Form from '../utils/Form';

    export default {
        props: [
            'timeslotId'
        ],

        data: function () {
            return {
                form: new Form({
                    member_id: null
                }),
                members: []
            };
        },

        mounted() {
            this.getMembers();
        },

        methods: {
            getMembers() {
                // axios.get(`/api/v1/timeslots/${this.timeslotId}/members`)
                axios.get(`/api/v1/members`)
                    .then(response => {
                        this.members = response.data;
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem fetching members.', type: 'error'});
                    });
            },

            addNewMember() {
                this.form.post(`/api/v1/timeslots/${this.timeslotId}/members`)
                    .then(response => {
                        this.$vuedals.close();
                        this.$parent.$emit('members-changed');
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem adding the member.', type: 'error'});
                    });
            }
        },

        destroyed() {
            this.form = null;
        }
    }
</script>
